import {CookieService} from '../services/cookie.service';

/**
 * This class is responsible for catching the first visited page URL and storing it in a cookie.
 * !IMPORTANT there is a similiar/equal class for b2b, consider updating / keeping it in sync
 */
export class FirstPageVisitCatcher {
    static readonly NAME = 'first_visited_page_url';
    public saveFirstPageVisited(): void {
        if (!this.getUrlFromCookies()) {
            this.setCookieUrl();
        }

        if (localStorage && !this.getUrlFromStorage()) {
            this.setStorageUrl();
        }
    }

    private getUrlFromCookies(): string | undefined {
        const cookie = CookieService.getCookie(FirstPageVisitCatcher.NAME);
        if (cookie) {
            return cookie[2];
        }

        return undefined;
    }

    private getUrlFromStorage(): string | undefined {
        const value = localStorage.getItem(FirstPageVisitCatcher.NAME);
        if (value) {
            return value;
        }

        return undefined;
    }

    private setCookieUrl(): void {
        CookieService.setCookie(FirstPageVisitCatcher.NAME, window.location.href, 7);
    }

    private setStorageUrl(): void {
        localStorage.setItem(FirstPageVisitCatcher.NAME, window.location.href);
    }
}

const firstPageVisitCatcher = new FirstPageVisitCatcher();
window.addEventListener('load', () => {
    firstPageVisitCatcher.saveFirstPageVisited();
});
